import React, { useEffect, useState } from 'react'
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { alphaNumeric, alphaNumericspace, isValidEmail, onlyAlphabets, onlyNumeric } from '../../../components/commonClass/CommonValidation';

const CorporateFinance = (props: any) => {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, CorporateId, setWarningMessages, domainWiseDisable } = props
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [dropdownList, setDropDownList] = useState<any>([])
  const [formErrors, setFormErrors] = useState<any>({})
  const [editcleardisabled, setEditClearDisabled] = useState(true)
  const [formValue, setFormValue] = useState({
    CorporateId: 0,
    CorporateFinanceId: 0,
    BillingContactName: '',
    BillingContactEmail: '',
    BillingContactPhone: '',
    BankMasterId: 0,
    AccountNo: '',
    IFSCCode: '',
    BranchName: '',
    CreditLimit: 0,
    CorporatePaymentTermsMasterId: 0,
    UserId: 0,
  })

  const getdropdowndata = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData('/midoffice/v1/getfinanceoption')
      if (list?.status) {
        const bankNameOption = list?.data?.bankNameOption?.map((obj: any) => ({
          label: obj?.BankName,
          value: obj?.BankMasterId,
        })) ?? [];
        const paymentTermsOption = list?.data?.paymentTermsOption?.map((obj: any) => ({
          label: obj?.PaymentTerms,
          value: obj?.TravelAgentPaymentTermsMasterId,
        })) ?? [];
        setDropDownList({ bankNameOption, paymentTermsOption });
      }
      else {
        setDropDownList([]);
      }
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
    dispatch(loaderActions.end());
  }

  const onChange = (name: any, val: any) => {
    setFormErrors({});
    setIsSaved((save: any) => ({ ...save, Finance: false }))
    setEditClearDisabled(false);
    const result = name === "CreditLimit" ? Number(val) : val
    setFormValue((form: any) => ({ ...form, [name]: result }))
  }

  const validation = () => {
    let status: boolean = true;
    const error: any = {}
    let regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
    if (formValue?.BillingContactEmail?.trim()?.length > 0 && !isValidEmail(formValue?.BillingContactEmail)) {
      error.BillingContactEmail = "Please provide valid email id.";
      status = false;
    }
    // if (formValue?.GSTNo?.trim()?.length > 0 && !regex.test(formValue?.GSTNo)) {
    //   error["GSTNo"] = "Please enter valid GST No.";
    //   status = false;
    // }
    setFormErrors(error);
    return status;
  }


  const saveDate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    if (validation()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let user: any = GetLocalStorage();
        formValue.UserId = user?.userMasterID
        formValue.CorporateId = Number(formValue.CorporateId)
        const RpsData = await postUsersData("/midoffice/v1/insertorupdatecorporatefinance", formValue);
        if (RpsData?.status) {
          setIsSaved((save: any) => ({ ...save, Finance: true }))
          setIsRedirect(true);
          setFormErrors({})
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        else {
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        dispatch(loaderActions.end());
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }

    }
  }

  const getbyid = async (id: any) => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData(`/midoffice/v1/getcorporatefinancebyid?corporateid=${id}`)
      if (list?.status && list?.data) {
        setFormValue({
          CorporateFinanceId: list?.data?.[0]?.CorporateFinanceId ? list?.data?.[0]?.CorporateFinanceId : 0,
          CorporateId: Number(id),
          AccountNo: list?.data?.[0]?.AccountNo ? list?.data?.[0]?.AccountNo : '',
          BankMasterId: list?.data?.[0]?.BankMasterId ? list?.data?.[0]?.BankMasterId : 0,
          BillingContactEmail: list?.data?.[0]?.BillingContactEmail ? list?.data?.[0]?.BillingContactEmail : '',
          BillingContactName: list?.data?.[0]?.BillingContactName ? list?.data?.[0]?.BillingContactName : '',
          BillingContactPhone: list?.data?.[0]?.BillingContactPhone ? list?.data?.[0]?.BillingContactPhone : '',
          BranchName: list?.data?.[0]?.BranchName ? list?.data?.[0]?.BranchName : '',
          CorporatePaymentTermsMasterId: list?.data?.[0]?.CorporatePaymentTermsMasterId ? list?.data?.[0]?.CorporatePaymentTermsMasterId : 0,
          CreditLimit: list?.data?.[0]?.CreditLimit ? list?.data?.[0]?.CreditLimit : '',
          IFSCCode: list?.data?.[0]?.IFSCCode ? list?.data?.[0]?.IFSCCode : '',
          UserId: 0,
        })
      }
      dispatch(loaderActions.end());
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
  }

  const clearData = () => {
    setIsSaved((save: any) => ({ ...save, Finance: false }))
    setFormValue((form: any) => ({
      ...form,
      BillingContactName: '',
      BillingContactEmail: '',
      BillingContactPhone: '',
      BankMasterId: 0,
      AccountNo: '',
      IFSCCode: '',
      BranchName: '',
      CreditLimit: 0,
      CorporatePaymentTermsMasterId: 0,
    }))
  }

  useEffect(() => {
    if (CorporateId) {
      setFormValue((form) => ({ ...form, CorporateId: Number(CorporateId) }));
      getbyid(CorporateId)
    }
  }, [CorporateId])

  useEffect(() => {
    getdropdowndata();
  }, [])

  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      saveDate()
    }
  }, [isConfirm])

  return (
    <div className='row mt-5'>
      <ColumnsDevider label='Billing Contact Name'>
        <input type="text"
          id="BillingContactName"
          className="form-control"
          name='BillingContactName'
          value={formValue?.BillingContactName}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('BillingContactName', onlyAlphabets(e?.target?.value))}
          maxLength={50}
          placeholder='Billing Contact Name' />
      </ColumnsDevider>

      <ColumnsDevider label='Billing Contact Email'>
        <input type="text"
          id="BillingContactEmail"
          className="form-control"
          name='BillingContactEmail'
          value={formValue?.BillingContactEmail}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('BillingContactEmail', e?.target?.value)}
          maxLength={150}
          placeholder='Billing Contact Email' />
        {formErrors?.BillingContactEmail && <div className='text-danger text-start fs_14'>{formErrors?.BillingContactEmail}</div>}
      </ColumnsDevider>

      <ColumnsDevider label='Billing Contact Phone'>
        <input type="text"
          id="BillingContactPhone"
          className="form-control"
          name='BillingContactPhone'
          value={formValue?.BillingContactPhone}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('BillingContactPhone', onlyNumeric(e?.target?.value))}
          maxLength={13}
          placeholder='Billing Contact Phone' />
      </ColumnsDevider>

      <div className='mb-2'><h4 className='fw-bold'>Bank Account</h4></div>

      <ColumnsDevider label='Bank Name'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={dropdownList?.bankNameOption}
          value={dropdownList?.bankNameOption?.filter((bankNameOption: any) => {
            return bankNameOption.value === formValue?.BankMasterId;
          })}
          onChange={(e: any) => onChange('BankMasterId', e?.value)}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          isSearchable={true}
          isClearable
        />
      </ColumnsDevider>

      <ColumnsDevider label='Account Number'>
        <input type="text"
          id="AccountNo"
          className="form-control"
          name='AccountNo'
          value={formValue?.AccountNo}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('AccountNo', onlyNumeric(e?.target?.value))}
          maxLength={16}
          placeholder='Account Number' />
      </ColumnsDevider>

      <ColumnsDevider label='IFSC Code'>
        <input type="text"
          id="IFSCCode"
          className="form-control"
          name='IFSCCode'
          value={formValue?.IFSCCode}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('IFSCCode', alphaNumeric(e?.target?.value))}
          maxLength={11}
          placeholder='IFSC Code' />
      </ColumnsDevider>

      <ColumnsDevider label='Branch Name'>
        <input type="text"
          id="BranchName"
          className="form-control"
          name='BranchName'
          value={formValue?.BranchName}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('BranchName', alphaNumericspace(e?.target?.value))}
          maxLength={50}
          placeholder='Branch Name' />
      </ColumnsDevider>

      <ColumnsDevider label='Credit Limit'>
        <input type="text"
          id="CreditLimit"
          className="form-control"
          name='CreditLimit'
          value={formValue?.CreditLimit ? formValue?.CreditLimit : ''}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => {
            Number(e.target.value) <= 5000000 &&
              onChange('CreditLimit', onlyNumeric(e?.target?.value))
          }}
          placeholder='Credit Limit' />
      </ColumnsDevider>

      <ColumnsDevider label='Payment Terms'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={dropdownList?.paymentTermsOption}
          value={dropdownList?.paymentTermsOption?.filter((paymentTermsOption: any) => {
            return paymentTermsOption.value === formValue?.CorporatePaymentTermsMasterId;
          })}
          onChange={(e: any) => onChange('CorporatePaymentTermsMasterId', e?.value)}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          isSearchable={true}
          isClearable
        />
      </ColumnsDevider>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={location?.state?.disabled || editcleardisabled || domainWiseDisable?.isExternalUser} onClick={() => saveDate()} id="btnAdd">{domainWiseDisable?.loginUserDomainMasterId !== 1 ? "Save AS Draft" : (location?.state?.viewtype === 'Update' ? 'Update' : 'Save')}</button>
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={editcleardisabled || location?.state?.disabled || domainWiseDisable?.isExternalUser} onClick={() => clearData()} id="btnAdd">Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" onClick={() => navigate('/corporate-management')} id="btnClear">Back</button>
      </div>
    </div>
  )
}

export default CorporateFinance